import { FormShell, FormGrid, FormField, FormFooter } from '../../../../../../generic/ui/FormLayout'
import { AccentButton } from '../../../../../../generic/ui/Button'
import CoolingSiteSelector from '../../../../../../generic/ui/Selectors/CoolingSiteSelector'
import { ICoolingSiteItem } from '../../../../../../modules/API/Defaults/models/coolingSites'
import { IPalletListWithDetails } from '../../../../../../modules/API/Pallets/models/palletList'
import PalletActionLayout from '../../shared/components/PalletActionLayout'
import PalletLookupField from '../../shared/components/PalletLookupField'
import FoundPalletCard from '../../shared/components/FoundPalletCard'

type Props = {
  palletNumber: string
  setPalletNumber: (value: string) => void
  isExternal: boolean
  setIsExternal: (value: boolean) => void
  palletFound: IPalletListWithDetails | null
  findPallet: (value?: string) => void
  coolingSites: ICoolingSiteItem[]
  selectedSite: ICoolingSiteItem | null
  setSelectedSite: (site: ICoolingSiteItem | null) => void
  submit: () => void
  canSubmit: boolean
}

const CoolingSiteView = ({
  palletNumber,
  setPalletNumber,
  isExternal,
  setIsExternal,
  palletFound,
  findPallet,
  coolingSites,
  selectedSite,
  setSelectedSite,
  submit,
  canSubmit,
}: Props) => (
  <PalletActionLayout title='עדכון קירור למשטח'>
    <FormShell>
      <FormGrid>
        <FormField label='מספר משטח' fullWidth>
          <PalletLookupField
            palletNumber={palletNumber}
            onPalletNumberChange={setPalletNumber}
            onScan={(value) => {
              setPalletNumber(value)
              findPallet(value)
            }}
            isExternal={isExternal}
            onToggle={setIsExternal}
          />
        </FormField>

        {palletFound && (
          <FormField fullWidth>
            <FoundPalletCard pallet={palletFound} />
          </FormField>
        )}

        {palletFound && (
          <FormField label='חדר קירור' fullWidth>
            <CoolingSiteSelector
              coolingSites={coolingSites}
              value={selectedSite}
              onSelect={setSelectedSite}
            />
          </FormField>
        )}
      </FormGrid>

      {canSubmit && (
        <FormFooter>
          <AccentButton type='button' onClick={submit} fullWidth={false}>
            עדכן
          </AccentButton>
        </FormFooter>
      )}
    </FormShell>
  </PalletActionLayout>
)

export default CoolingSiteView
